export function activateGamerMode(gamerKeyBoard) {
    gamerKeyBoard.active = !gamerKeyBoard.active;
}